import { IHeaderAngularComp } from '@ag-grid-community/angular';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { ROUTING_PATH } from '@shared/constants/routingPath';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
  styles: [
    `
      :host {
        width: 100%;
      }
    `,
  ],
  template: `
    <div class="whitespace-normal text-center">
      <a class="aux-link cursor-pointer" [routerLink]="routerLink">Prepaid</a>
      Impact
    </div>
  `,
})
export class AgPrepaidHeaderComponent implements IHeaderAngularComp {
  protected readonly routerLink = `/${ROUTING_PATH.CLOSING.INDEX}/${ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.INDEX}/${ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.PREPAIDS}`;

  agInit(): void {}

  refresh(): boolean {
    return false;
  }
}
